export default {
	label: 'As seen on',
	name: 'as-seen-on',
	widget: 'object',
	required: true,
	fields: [
		{
			label: 'Title',
			name: 'title',
			widget: 'string'
		},
		{
			label: 'Logos',
			name: 'logos',
			widget: 'list',
			fields: [
				{
					name: 'image',
					label: 'Image',
					required: true,
					widget: 'image'
				},
				{
					name: 'name',
					label: 'Name',
					required: false,
					widget: 'text'
				}
			]
		}
	]
};
